import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const templesSlice = createSlice({
  name: 'temples',
  initialState: {
    templeData: [],
    selectedTemple: false
  },

  reducers: {
    setTempleData: (state, action) => {
      state.templeData = action.payload;
    },

    setSelectedTemple: (state, action) => {
      const selectedTemple = state.templeData.find(el => el.id === action.payload);
      state.selectedTemple = selectedTemple;
    },

    setSelectPin: (state, action) => {
      const newData = [...state.templeData];

      newData.forEach(el => {
        if (el.id === action.payload) {
          el.isSelected = true;
        }
      });

      state.templeData = newData;
    },

    setDeselectPins: (state, action) => {
      const newData = [...state.templeData];
      newData.forEach(el => el.isSelected = false);
      state.templeData = newData;
    }
  }
});

export const { setTempleData, setSelectedTemple, setSelectPin, setDeselectPins } = templesSlice.actions;

// Actions
export const getTempleData = () => dispatch => {
  async function fetchData() {
    await fetch(`${process.env.PUBLIC_URL}/data/makino-map.json`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(res => res.json())
    .then(data => {
      const tempData = data;
      tempData.forEach((el, index) => {
        el.id = index;
        el.isSelected = false;
      });

      dispatch(setTempleData(tempData));
    })
    .catch(e => console.log(e.message));
  }

  fetchData();
}

export const selectPin = id => (dispatch, getState) => {
  dispatch(setSelectPin(id));
}

export const deselectPins = () => dispatch => {
  dispatch(setDeselectPins());
}

export const updateSelectedTemple = id => dispatch => {
  dispatch(setSelectedTemple(id));
}

export default templesSlice.reducer;
